var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCompact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82932 0C-8.6236 24.189 3.4487 33.3702 13.8144 35.0783C10.9313 26.9366 9.78066 17.7667 10.9313 11.0073C11.8036 17.9586 14.788 26.9119 17.089 31.8164C17.0824 29.5382 17.5996 27.1801 19.002 25.0212C20.4756 22.7525 22.7717 20.9356 26.0261 19.7002C25.8358 9.65139 15.6613 2.72721 8.82932 0Z",
    fill: "#f6b26b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7044 20.1772C17.8417 19.6041 17.8417 31.0665 20.7184 37.9439C23.5951 33.3589 28.1977 29.9202 30.499 29.3471C30.0611 29.9288 29.401 30.7441 28.6501 31.6714C26.4418 34.3988 23.4491 38.095 23.0197 39.6632C38.2085 42.4142 41.0468 27.6277 39.7044 20.1772Z",
    fill: "#f6b26b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCompact);
export default __webpack_public_path__ + "static/media/logo_compact.42e2a8ee8de74731316b80b0b12d6c5b.svg";
export { ForwardRef as ReactComponent };